import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default new Router({ 
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/login",
      name: "login",
      component: r =>
        require.ensure([], () => r(require("@/components/Login"), "demo1"))
    },
    {
      path: "/register",
      name: "register",
      component: r =>
        require.ensure([], () => r(require("@/components/Register"), "demo1"))
    },
    /**忘记密码 */
    {
      path: "/findPassword",
      name: "findPassword",
      component: r =>
        require.ensure([], () =>
          r(require("@/components/FindPassword"), "demo1")
        )
    },
    {
      path: "/userinfo",
      name: "userinfo",
      component: r =>
        require.ensure([], () => r(require("@/components/UserInfo"), "demo1"))
    },
    /*我的注册列表*/
    {
      path: "/myRegisterList",
      name: "myRegisterList",
      component: r =>
        require.ensure([], () =>
          r(require("@/components/MyRegisterList"), "demo1")
        )
    },
    /*我的消息*/
    {
      path: "/message",
      name: "message",
      component: r =>
        require.ensure([], () => r(require("@/components/Message"), "demo1"))
    },
    /*首页*/
    {
      path: "",
      name: "index",
      redirect: "/home",
      component: r =>
        require.ensure([], () => r(require("@/components/Index"), "demo1")),
      children: [
        /*首页*/
        {
          path: "/home",
          name: "home",
          component: r =>
            require.ensure([], () =>
              r(require("@/components/home/Home"), "demo1")
            )
        },
        /*文章详情*/
        {
          path: "/detail/:id",
          name: "resourceDetail",
          component: r =>
            require.ensure([], () => r(require("@/components/Detail"), "demo1"))
        },
        /*搜索 */
        {
          path: "/search",
          name: "search",
          component: r =>
            require.ensure([], () => r(require("@/components/Search"), "demo1"))
        },
        /*中心概况*/
        {
          path: "/center",
          name: "center",
          component: r =>
            require.ensure([], () =>
              r(require("@/components/center/Center"), "demo1")
            )
        },
        /*循证动态*/
        {
          path: "/new",
          name: "new",
          component: r =>
            require.ensure([], () =>
              r(require("@/components/dynamic/new"), "demo1")
            )
        },

        /*循证实践资源区*/
        {
          path: "/resource",
          redirect: "/resource/recommend",
          component: r =>
            require.ensure([], () =>
              r(require("@/components/resource/side"), "demo1")
            ),
          children: [
            {
              path: "/resource/recommend",
              name: "recommend",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/resource/Recommend"), "demo1")
                )
            },
            {
              path: "/resource/summary",
              name: "summary",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/resource/summary"), "demo1")
                )
            },
            {
              path: "/resource/guide",
              name: "guide",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/resource/Guide"), "demo1")
                )
            },
            {
              path: "/resource/application",
              name: "application",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/resource/application"), "demo1")
                )
            }
          ]
        },
        /*循证学苑*/
        {
          path: "/quality",
          name: "quality",
          component: r =>
            require.ensure([], () =>
              r(require("@/components/school/Quality"), "demo1")
            )
        },
        /*循证学苑*/
        {
          path: "/school",
          redirect: "/school/quality",
          component: r =>
            require.ensure([], () =>
              r(require("@/components/school/Side"), "demo1")
            ),
          children: [
            {
              path: "/school/quality",
              name: "quality",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/school/Quality"), "demo1")
                )
            },
            {
              path: "/school/integratedApproach",
              name: "integratedApproach",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/school/IntegratedApproach"), "demo1")
                )
            },
            {
              path: "/school/applicationMethods",
              name: "applicationMethods",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/school/ApplicationMethods"), "demo1")
                )
            }
          ]
        },
        /*循证注册平台*/
        {
          path: "/summary",
          name: "summary",
          redirect: "/summary/info",
          component: r =>
            require.ensure([], () =>
              r(require("@/components/platform/summary/side"), "demo1")
            ),
          meta: {
            isLogin: true // 自定义一个属性，true需要登录权限
          },
          children: [
            {
              path: "/summary/info",
              name: "info",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/platform/summary/Info"), "demo1")
                ),
              meta: {
                isLogin: true // 自定义一个属性，true需要登录权限
              }
            },
            {
              path: "/summary/problem",
              name: "problem",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/platform/summary/Problem"), "demo1")
                ),
              meta: {
                isLogin: true // 自定义一个属性，true需要登录权限
              }
            },
            {
              path: "/summary/team",
              name: "team",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/platform/summary/Team"), "demo1")
                ),
              meta: {
                isLogin: true // 自定义一个属性，true需要登录权限
              }
            },
            {
              path: "/registerResources/phone",
              name: "registerResources/phone",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/platform/registerResources"), "demo1")
                )
            }
          ]
        },
        {
          path: "/application",
          name: "application",
          redirect: "/application/info",
          component: r =>
            require.ensure([], () =>
              r(require("@/components/platform/application/side"), "demo1")
            ),
          meta: {
            isLogin: true // 自定义一个属性，true需要登录权限
          },
          children: [
            {
              path: "/application/info",
              name: "info",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/platform/application/Info"), "demo1")
                ),
              meta: {
                isLogin: true // 自定义一个属性，true需要登录权限
              }
            },
            {
              path: "/application/problem",
              name: "problem",
              component: r =>
                require.ensure([], () =>
                  r(
                    require("@/components/platform/application/Problem"),
                    "demo1"
                  )
                ),
              meta: {
                isLogin: true // 自定义一个属性，true需要登录权限
              }
            },
            {
              path: "/application/team",
              name: "team",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/platform/application/Team"), "demo1")
                ),
              meta: {
                isLogin: true // 自定义一个属性，true需要登录权限
              }
            },
            {
              path: "/application/design",
              name: "team",
              component: r =>
                require.ensure([], () =>
                  r(
                    require("@/components/platform/application/Design"),
                    "demo1"
                  )
                ),
              meta: {
                isLogin: true // 自定义一个属性，true需要登录权限
              }
            },
            {
              path: "/registerResources/phone",
              name: "registerResources/phone",
              component: r =>
                require.ensure([], () =>
                  r(require("@/components/platform/registerResources"), "demo1")
                )
            }
          ]
        },
        {
          path: "/registerResources",
          name: "registerResources",
          component: r =>
            require.ensure([], () =>
              r(require("@/components/platform/registerResources"), "demo1")
            )
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js